export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40512b4ec9f46d3eeb79f310f09ecd2de710d03a7f&name=revalidateCommunity!'